import React from 'react'
import { Offer } from '../../models/shared/Offer'
import { formatDate } from '../../utils/date';
import { OfferAuditRecord } from '../../models/shared/OfferAuditRecord';
import { useText } from '../../context/TextContext';

interface Props {
    offer: Offer,
    hideOpens?: boolean
    className?: string
}

export default function OfferLog(props: Props) {
    const allRecords = props.offer.auditRecords || [];
    const filteredRecords = allRecords.filter(record => record.type !== 'visited' || !props.hideOpens);
    filteredRecords.sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime());

    const text = useText();

    if (!filteredRecords.length) {
        return null;
    }

    const renderText = (record: OfferAuditRecord) => {
        switch (record.type) {
            case 'visited':
                return text.offerOpenedByCustomer
            case 'accepted':
                return <span className='text-success text-bold'>{text.offerAccepted}</span>
            case 'comment':
                return <span className='text-info'>{text.comment}</span>
            default:
                return ''
        }
    }


    return (
        <div className={`${props.className} d-flex flex-column gap-2`}>
            {filteredRecords.map((record, index) => (
                <div key={index} className='d-flex flex-column'>
                    <span className='text-muted small'>{formatDate(record.createdAt)}</span>
                    <span className='text-secondary small'>{renderText(record)}</span>
                    {record.extras.comment && <pre className='text-secondary small m-0' style={{
                        borderLeft: "2px solid #ccc",
                        paddingLeft: "8px",
                    }}>{record.extras.comment}</pre>}
                </div>
            ))}
        </div>
    )
}
